import { optionTitle_forwarding } from 'owa-locstrings/lib/strings/optiontitle_forwarding.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const ForwardingOption: LazyOption = createLazyOption(
    {
        key: 'forwardingOption',
        titleStringKey: optionTitle_forwarding,
        hideTitleInFullOptions: true,
        searchTermsStringKey: optionTitle_forwarding,
        isHidden: () => IsShadowMailboxUser(),
        allowedOptionKeys: ['Forwarding'],
    },
    lazyFullModule,
    m => m.default
);
export default ForwardingOption;
